// extracted by mini-css-extract-plugin
export var divider = "_nr-0";
export var systemMessage = "_nr-1";